/**
 * noKnownItems.js — TEST 3.04 (client half), patient push 1.
 *
 * A medical record that says "No known allergies" or "No current medications" is a
 * NEGATIVE finding, not an entry. The document extractor (orella-api
 * /api/v1/ai/parse-medical-document) returned it as an allergy ITEM, and onboarding saved
 * "No Known Allergies" next to a real allergy; the physician's hand-off printed it as a
 * drug allergy. useOnboardingStore.applyAutofillResult drops these phrases and sets the
 * section's own flag instead (noKnown / none), and only when no real entry survives.
 *
 * ★ EXACT MATCH ONLY, after normalising case, surrounding space, inner runs of space and
 *   trailing punctuation. Never a substring: a real drug or substance name is never swept in.
 * ★ The same two lists are planned for the server (orella-api `_NKA_ALLERGY_PHRASES` /
 *   `_NKA_MED_PHRASES`, U2 step A3, not built yet). The repos share no package; keep the
 *   lists identical by hand when that lands. An unmatched phrase stays a visible item that
 *   the patient can delete (Q41: the starting list ships, widened from real extractions).
 *
 * No imports: scripts/check-autofill-merge.mjs loads this in node.
 */
const NKA_ALLERGY_PHRASES = new Set([
  'no known allergies',
  'nkda',
  'no known drug allergies',
  'none',
  'no allergies',
  'denies any allergies',
  'no known food or drug allergies',
])

const NKA_MED_PHRASES = new Set([
  'none',
  'no current medications',
  'no medications',
  'not currently taking any medications',
  'denies any medications',
  'n/a',
])

export function normalizeNkaPhrase(value) {
  return String(value ?? '')
    .toLowerCase()
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/[.!;:,]+$/, '')
    .trim()
}

export const isNkaAllergyPhrase = (name) => NKA_ALLERGY_PHRASES.has(normalizeNkaPhrase(name))
export const isNkaMedPhrase = (name) => NKA_MED_PHRASES.has(normalizeNkaPhrase(name))
